const withSuggestionsFromDataProp = (dataResponse = {}) => {
   return dataResponse?.data;
};

const withSuggestionsFromDataPropAndNameAsLabel = (dataResponse = {}) => {
   return withSuggestionsFromDataProp(dataResponse).map(({ id, name, ...rest }) => ({
      id,
      name,
      label: name,
      ...rest,
   }));
};

const withSuggestionFromDataPropAndLabelAsName = (dataResponse = {}) => {
   return dataResponse.map(({ id, label, ...rest }) => ({
      id,
      name: label,
      label,
      ...rest,
   }));
};


const withSuggestionsFromDataPropAndNameAsLabelLocationList = (dataResponse = {}) => {
   return dataResponse?.locationList?.map(({ id, name, ...rest }) => ({
      id,
      name,
      label: name,
      ...rest,
   }));
};

const withSuggestionsFromDataPropAndIdAsValueAndNameAsLabel = (dataResponse = {}) => {
   return withSuggestionsFromDataProp(dataResponse).map(({ id, name, ...rest }) => ({
      id,
      name,
      label: name,
      value: id,
      ...rest,
   }));
};

export default {
   withSuggestionsFromDataProp,
   withSuggestionsFromDataPropAndNameAsLabel,
   withSuggestionsFromDataPropAndIdAsValueAndNameAsLabel,
   withSuggestionsFromDataPropAndNameAsLabelLocationList,
   withSuggestionFromDataPropAndLabelAsName,
};

